/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_phred_error_prob = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error probability`)
};

const es_phred_error_prob = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Probabilidad de error`)
};

const de_phred_error_prob = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehlerwahrscheinlichkeit`)
};

const nl_phred_error_prob = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foutkans`)
};

const fr_phred_error_prob = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Probabilité d'erreur`)
};

const it_phred_error_prob = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Probabilità di errore`)
};

const pt_br2_phred_error_prob = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Probabilidade de erro`)
};

const pt_phred_error_prob = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Probabilidade de erro`)
};

const ja_phred_error_prob = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エラー確率`)
};

const zh_phred_error_prob = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`错误概率`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const phred_error_prob = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.phred_error_prob(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("phred_error_prob", locale)
	if (locale === "en") return en_phred_error_prob(inputs)
	if (locale === "es") return es_phred_error_prob(inputs)
	if (locale === "de") return de_phred_error_prob(inputs)
	if (locale === "nl") return nl_phred_error_prob(inputs)
	if (locale === "fr") return fr_phred_error_prob(inputs)
	if (locale === "it") return it_phred_error_prob(inputs)
	if (locale === "pt-BR") return pt_br2_phred_error_prob(inputs)
	if (locale === "pt") return pt_phred_error_prob(inputs)
	if (locale === "ja") return ja_phred_error_prob(inputs)
	return zh_phred_error_prob(inputs)
};